import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { SnackBarService } from './data/repository/utils-repository/snack-bar.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  offline: boolean = false;
  constructor(public updates: SwUpdate, private snakbar: SnackBarService) {
    if (updates.isEnabled) {
      interval(6 * 60 * 60).subscribe(() =>
        updates.checkForUpdate().then(() => console.log('checking for updates'))
      );
    }
    this.internetStatus();
    this.internetEventListner();
    interval(6 * 60 * 60).subscribe(() => {
      this.internetStatus();
    });
  }

  public internetStatus() {
    const navigator: Navigator = window.navigator;
    if ('onLine' in navigator) {
      if (navigator.onLine) {
        console.log('online');
        if (this.offline) {
          this.offline = false;
          this.snakbar.showSnackBar('ارتباط اینترنت برقرار شد');
        }
      } else {
        if (!this.offline) {
          this.offline = true;
          this.snakbar.showSnackBar('قطع ارتباط با اینترنت');
        }
      }
    }
  }
  public internetEventListner() {
    let that = this;
    window.addEventListener('offline', function (e) {
      if (!that.offline) {
        that.offline = true;
        that.snakbar.showSnackBar('قطع ارتباط با اینترنت');
      }
    });

    window.addEventListener('online', function (e) {
      if (that.offline) {
        that.offline = false;
        that.snakbar.showSnackBar('ارتباط اینترنت برقرار شد');
      }
    });
  }
  public checkForUpdates(): void {
    this.updates.available.subscribe((event) => this.promptUser());
  }

  private promptUser(): void {
    console.log('updating to new version');
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}
